export interface HistoryPhysicalExamClinicalInfo {
  isPatientImmunocompromised: string;
  isTumorLocatedOnHeadOrNeck: string;
  tumorDiameter: string;
  additionalHistoryPhysicalExam: string[];
}

export interface PathologySurgicalFindingsClinicalInfo {
  isPerineuralInvolvement: string;
  isPoorlyDifferentiated: string;
  additionalPathologySurgicalFindings: string[];
}

export const emptyHistoryPhysicalExamClinicalInfo =
  (): HistoryPhysicalExamClinicalInfo => ({
    isPatientImmunocompromised: "",
    isTumorLocatedOnHeadOrNeck: "",
    tumorDiameter: "",
    additionalHistoryPhysicalExam: [],
  });

export const emptyPathologySurgicalFindingsClinicalInfo =
  (): PathologySurgicalFindingsClinicalInfo => ({
    isPerineuralInvolvement: "",
    isPoorlyDifferentiated: "",
    additionalPathologySurgicalFindings: [],
  });
